import Column from 'components/core/Column'
import { HtmlEditor } from 'components/core/HtmlEditor'
import Row from 'components/core/Row'
import TextInput from 'components/core/TextInput'
import Typography from 'components/core/Typography'
import { FileAttachmentButton } from '../FileAttachmentButton'

export type SendEmailFormValues = {
    to: string
    cc: string
    bcc: string
    from: string
    subject: string
    htmlContent: string
}

export type SendEmailFormErrors = Partial<
    Record<keyof SendEmailFormValues, string>
>

export type SendEmailFormProps = SendEmailFormValues & {
    isFromDisabled?: boolean
    isShowAttachmentsButton?: boolean
    isShowFromField?: boolean
    isShowSubjectField?: boolean
    customComponents?: React.ReactNode
    files: File[]
    errors: SendEmailFormErrors
    onChangeFiles: (files: File[]) => void
    onChange: (key: keyof SendEmailFormValues, value: string) => void
}

export const SendEmailForm = ({
    isFromDisabled,
    isShowAttachmentsButton,
    isShowFromField = true,
    isShowSubjectField = true,
    to,
    cc,
    bcc,
    from,
    subject,
    htmlContent,
    errors,
    files,
    customComponents,
    onChangeFiles,
    onChange,
}: SendEmailFormProps) => {
    const _onChange = (key: keyof SendEmailFormValues) => (value: string) =>
        onChange(key, value)

    return (
        <Column fullWidth fullHeight gap="p2">
            <TextInput
                label="To:"
                placeholder="To:"
                value={to}
                error={errors.to}
                onChange={_onChange('to')}
            />
            <Row gap="p2">
                <TextInput
                    label="Cc:"
                    placeholder="Cc:"
                    value={cc}
                    error={errors.cc}
                    onChange={_onChange('cc')}
                />
                <TextInput
                    label="Bcc:"
                    placeholder="Bcc:"
                    value={bcc}
                    error={errors.bcc}
                    onChange={_onChange('bcc')}
                />
            </Row>
            {isShowFromField && (
                <TextInput
                    isDisabled={isFromDisabled}
                    label="From:"
                    placeholder="From:"
                    value={from}
                    error={errors.from}
                    onChange={_onChange('from')}
                />
            )}
            {isShowSubjectField && (
                <TextInput
                    label="Subject:"
                    placeholder="Subject:"
                    value={subject}
                    error={errors.subject}
                    onChange={_onChange('subject')}
                />
            )}

            {isShowAttachmentsButton && (
                <Row gap="p1" alignItems="center">
                    <FileAttachmentButton onFilesSelected={onChangeFiles} />
                    {files.length > 0 && (
                        <Typography color="primary" variant="body2">
                            {files.map((f) => f.name).join(', ')}
                        </Typography>
                    )}
                </Row>
            )}
            <HtmlEditor
                fullHeight
                value={htmlContent}
                toolbarOptions={[
                    'bold',
                    'italic',
                    'underline',
                    'bulletList',
                    'numberedList',
                    'link',
                ]}
                onChange={_onChange('htmlContent')}
            />
            {customComponents}
        </Column>
    )
}
